export default __webpack_public_path__ + "static/media/Bottom Navigation.7ba058c2.svg";